module.exports = __webpack_public_path__ + "static/media/arise.04e9cacf.png";